import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type AvatarType = 'eye-monster' | 'rabbit-monster' | 'smart-monster'
export type AvatarColor = 'blue' | 'gray' | 'green' | 'red'

export interface UserProfile {
  nickname: string
  avatarType: AvatarType
  avatarColor: AvatarColor
  avatarImagePath: string
  ID?: number
}

interface UserState {
  userProfile: UserProfile | null

  setUserProfile: (profile: UserProfile) => void
  clearUserProfile: () => void
  updateNickname: (nickname: string) => void
  updateAvatar: (avatarType: AvatarType, avatarColor: AvatarColor) => void
}

export const useUserStore = create<UserState>()(
  persist(
    (set, get) => ({
      userProfile: null,

      // 유저 프로필 설정
      setUserProfile: (profile: UserProfile) => {
        set({
          userProfile: profile,
        })
      },

      // 유저 프로필 초기화 (로그아웃시 호출)
      clearUserProfile: () => {
        set({
          userProfile: null,
        })
      },

      // 닉네임 업데이트
      updateNickname: (nickname: string) => {
        const currentProfile = get().userProfile
        if (currentProfile) {
          set({
            userProfile: {
              ...currentProfile,
              nickname,
            },
          })
        }
      },

      updateAvatar: (avatarType: AvatarType, avatarColor: AvatarColor) => {
        const currentProfile = get().userProfile
        if (currentProfile) {
          const avatarImagePath = `/assets/${avatarType.replace('-monster', '')}-${avatarColor}-monster.png`
          set({
            userProfile: {
              ...currentProfile,
              avatarType,
              avatarColor,
              avatarImagePath,
            },
          })
        }
      },
    }),
    {
      name: 'user-storage', // sessionStorage 키
      partialize: (state) => ({
        userProfile: state.userProfile,
      }),
    }
  )
)
